import { DatePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { AdminSessionTimeoutService } from '../../../core/session/admin-session-timeout.service';

@Component({
  selector: 'app-session-timeout',
  standalone: true,
  imports: [DatePipe, TranslateModule, ButtonModule, DialogModule],
  template: `
    @if (timeout.absoluteWarningVisible()) {
      <div class="absolute-banner" role="status">
        <i class="pi pi-clock"></i>
        <span>
          {{
            'sessions.absoluteWarning'
              | translate: { time: (timeout.absoluteEndsAt() | date: 'shortTime') }
          }}
        </span>
      </div>
    }

    <p-dialog
      [visible]="timeout.idleWarningVisible()"
      [modal]="true"
      [closable]="false"
      [closeOnEscape]="false"
      [style]="{ width: '30rem', maxWidth: '94vw' }"
      [header]="'sessions.idleWarningTitle' | translate"
    >
      <p class="warning-copy">{{ 'sessions.idleWarningCopy' | translate }}</p>
      <ng-template #footer>
        <p-button
          [label]="'sessions.signOutNow' | translate"
          severity="secondary"
          [text]="true"
          (onClick)="timeout.signOutNow()"
        />
        <p-button
          [label]="'sessions.staySignedIn' | translate"
          icon="pi pi-check"
          (onClick)="timeout.staySignedIn()"
        />
      </ng-template>
    </p-dialog>
  `,
  styles: [
    `
      .absolute-banner {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.55rem;
        padding: 0.65rem 1rem;
        color: #7c2d12;
        background: #ffedd5;
        border-bottom: 1px solid #fdba74;
        font-weight: 600;
      }
      .warning-copy {
        color: var(--text-color-secondary);
        line-height: 1.55;
      }
    `,
  ],
})
export class SessionTimeout implements OnInit {
  readonly timeout = inject(AdminSessionTimeoutService);

  ngOnInit(): void {
    this.timeout.start();
  }
}
